import { Participant } from '../../processing/models/processing.models';
import { ValidationMessage } from '../../_shared/models/shared.models';
import { isNullOrEmpty, isInvalidEmail } from '../../_shared/shared.service';

export class Product {
	Id: number;
	Name: string;
	Price: number;
	Category: string;
	CategoryId: number;
	AccountId?: number;
	BudgetCode: string;
	NotificationEmail: string;
	Description: string;
	IsClosed: boolean;
	IsDeleted: boolean;
	Quantity: number;
	CedrSystem: string;
	ConfirmationUrl: string;
	TinyUrl: string;
	NeedTinyUrl: boolean;
	PayPortal: boolean;
	DateCreated?: Date;
	IsSjcoeItem: boolean;
	Participants: Participant[];
	PortalLogo: string;
	PortalTitle: string;
	EndDate: string;
	constructor(Data: any) {
		Object.assign(this, Data);
	}

	isValid(): ValidationMessage {
		const errorAry: string[] = [];
		if (isNullOrEmpty(this.Name)) {
			errorAry.push('Name');
		}
		if (typeof this.Price !== 'number' || this.Price === 0) {
			errorAry.push('Price');
		}
		if (isNullOrEmpty(this.BudgetCode) || this.BudgetCode.length !== 4) {
			errorAry.push('Management Code');
		}
		if (this.Category === 'NULL') {
			errorAry.push('Cedr System Category');
		}
		if (isNullOrEmpty(this.NotificationEmail)) {
			errorAry.push('Email');
		} else if (this.NotificationEmail.search(',') >= 0) {
			const emails = this.NotificationEmail.split(',');
			emails.forEach(element => {
				if (isInvalidEmail(element) && !errorAry.includes('Email')) {
					errorAry.push('Email');
				}
			});
		} else if (isInvalidEmail(this.NotificationEmail)) {
			errorAry.push('Email');
		}
		return {
			HasError: errorAry.length > 0,
			Message: `Missing or Invalid fields: ${errorAry.join(', ')}`,
		};
	}
}
